export type MjpegViewKind = 'live' | 'annotated';

/**
 * Cloud MJPEG cameras that must use stable ffmpeg (not low_latency live):
 *
 * - cam_a6c12b0f3d94: looped accident_demo relay; low_latency never decodes (placeholders only).
 * - cam_a1bc71b70d77: warehouse live RTSP relay; low_latency adds ffmpeg -re, which paces
 *   through edge backlog at wall-clock rate so OSD can lag minutes behind while HTTP still
 *   reports fresh frames. Stable avoids -re and catches up after reconnect.
 * - cam_walkway_zone_demo: looped MediaMTX public-dataset reel; low_latency flaps between
 *   real JPEGs and 1x1 placeholders, which render as a grey center box over the poster.
 *
 * @see scripts/dev/pin_demo5_a1bc_camera.sh
 */
export const MJPEG_STABLE_MODE_CAMERA_IDS = new Set([
  'cam_a6c12b0f3d94',
  'cam_a1bc71b70d77',
  'cam_walkway_zone_demo',
]);

export function preferredMjpegModeForCamera(
  cameraId: string,
  viewKind: MjpegViewKind = 'live',
): 'stable' | 'low_latency' {
  if (viewKind === 'annotated') return 'stable';
  if (MJPEG_STABLE_MODE_CAMERA_IDS.has(cameraId)) return 'stable';
  // RTSP cameras (cam_*) usually start fast in low-latency mode.
  return cameraId.startsWith('cam_') ? 'low_latency' : 'stable';
}
